import { useNavigate } from 'react-router-dom-v6'

import { UserForm, type UserFormValues } from '../components/UserForm'
import { useRegisterUser } from '../hooks'

// Registers a user with a password set directly by the admin — for tenants
// whose user emails aren't real mailboxes, where the invite-link flow
// (InviteUser) can't reach the user.
export function RegisterUser() {
  const navigate = useNavigate()
  const { mutateAsync: register } = useRegisterUser()

  const onSubmit = async (values: UserFormValues) => {
    await register(values)
    navigate('/users', { replace: true })
  }

  return <UserForm mode="register" onSubmit={onSubmit} />
}
